module.exports = __webpack_public_path__ + "static/media/comin_soon_2024.994669c0.png";